import { useIntl } from '~/hooks/useIntl';
import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  price: number | undefined;
};

export const ProductPriceCell = ({ price }: Props) => {
  const { formatCurrency } = useIntl();

  return <span className={desktopTruncateStyle}>{price ? formatCurrency(price) : '-'}</span>;
};
